import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import agent from '../../app/api/agent';
import {
  operatorPerformanceType,
  plWiseDataType,
  QcReportMetadata,
  reelWiseDataType,
  rejectHistoryType,
  titleWiseDataType,
  cutliststatusreport,
  qcperformacedata,
  defectData,
  ReportDetailsItem,
  ClusterCapacity,
  monthlyProductivitydata,
  DaywiseHourAnalysis,
  RestorationProductivity,
  TitleWiseDashboard,
  pcrReportBasic,
  pcrComments,
  pcrCommentsPayload,
  pcrReportdetails,
  pcrReportinforamation,
  frrReportAddress,
  defectType,
  FrrInformData,
  getfrrReportAddress,
  getFrrInformData,
  honeyCombStatusReport,
  operationReport,
  OperationReportClustorDetails,dropTitleCode,ProductivityReportbyTitleBreakUp,Capacityindividual,
  FrrInformationTitleDetails,
} from '../../app/models/Restoration';
import { InventoryList,InventoryListDetails,MetaDataTemplate, Options} from '../../app/models/TitleCreate'
import { store } from '../../app/stores/store';
import NFAI_Restoration_SmartflowServices from '../../app/stores/NFAI_Restoration_Smartflow/service';
export default class RestorationStore {
  QcmetadataRegistry = new Map<string, QcReportMetadata>();
  qcData: QcReportMetadata | any[] = [];
  titleWiseData: titleWiseDataType[] = [];
  reelWiseData: reelWiseDataType[] = [];
  plWiseData: plWiseDataType[] = [];
  qualityData: rejectHistoryType[] = [];
  loading: boolean = false;
  manDaysData: any[] = [];
  operatorPerformanceData: operatorPerformanceType[] = [];
  manDaysReportTitleInfo: { key: string; value: string; text: string }[] = [];
  DateFormatInfo: string[] = [];
  restorationReportLoader: boolean = false;
  responseForDefectData: defectData[] = [];
  performanceTitleCode: { key: string; value: string; text: string }[] = [];
  cutlistStatusReportData: cutliststatusreport[] = [];
  titleCodeData: any[] = [];
  titleCodecountdata: number = 0;
  dataqualityteamtitleperformace: qcperformacedata[] = [];
  pcEmpIdGet: any[] = [];
  leadEmpIdGet: any[] = [];
  operatorEmpIdGet: any[] = [];
  empNameFind: any[] = [];
  teamList: any[] = [];
  cutlistQTLoader: boolean = false;
  leadEmpId: string[] = [];
  reportDetails:any[]=[];
  ClusterHeadEmployeeID:string[]=[];
  ClusterCapcityData:ClusterCapacity[]=[];
  ClusterCapcityIndividualData:Capacityindividual[]=[];
  DayWiseHours:DaywiseHourAnalysis[]=[];
  RestorationProductivity:RestorationProductivity[]=[];
  monthlyProductivitydata:monthlyProductivitydata[]=[];
  monthlyProductivityYearData: any[] = [];
  monthlyProductivityYearMonthData:any[]=[];
  TitleWiseDashboardData:TitleWiseDashboard[]=[];
  pcrCommentsDetails:pcrComments[]=[];
  getFrrReportAddress:getfrrReportAddress[]=[];
  getFrrInformData:getFrrInformData={
    ffrNo:0,
    titleCode:'',
    ffrDate:'',
    inputFrame:'',
    noOfReel:'',
    outputFrame:'',
    clientRequirementLevel:'',
    resolution:'',
    generalSummary:'',
    updatedBy:'',
   
  }
  
  //DefectTypes:any[]=[];
  DefectTypesValue:defectType[]=[];
  pcrReportinforamationdata:pcrReportinforamation={
    pcrNumber:'',
    pcrDate:'',
    client:'',
    reels:'',
    shots:'',
    cluster:'',
    end_Date:'',
    qcFrame:0,
    fqaFrame:0,
    titlecode:'',
    level:'',
    input_Metrial:'',
    outPut_Metrial:'',
    iM_Nos:'',
    oM_Nos:'',
    our_OM_Nos:'',
    lob_Split_up:'',
    location_Split_up:'',
    work_Advice:'',
    contract_Review:'',
    analysis_Report:'',
    qA_Feedback_Tracker:'',
    estimation_to_Client:'',
    content_Report:'',
    shot_Estimate_Report:'',
    project_allocation_Sheet:'',
    daily_Tracker:'',
    estimation_Report:'',
    final_Restoration_Report:'',
    project_Plan_and_Tracker:'',
    ltO_Log:'',
    detection_Approval_reacd:'',
    project_Brief:'',
    qC_Feedback_Tracker:'',
    no_of_ReworkingHrs:'',
    drE_QC:'',
    drE_Client:'',
    notes:'',
    customer_Complaints:'',
    improvements:'',
    actualDeliveryDate:'',
    dayDifferent:0
  }
  pcrReportdetailsData:pcrReportdetails={
    Titlecode: '',
    level:'',
    Input_Metrial: '',
    OutPut_Metrial: '',
    IM_Nos: '',
    OM_Nos: '',
    Our_OM_Nos: '',
    Lob_Split_up: '',
    Location_Split_up: '',
    Work_Advice: '',
    Contract_Review: '',
    Analysis_Report: '',
    QA_Feedback_Tracker: '',
    Estimation_to_Client: '',
    Content_Report: '',
    Shot_Estimate_Report: '',
    Project_allocation_Sheet: '',
    Daily_Tracker: '',
    Estimation_Report: '',
    Final_Restoration_Report: '',
    LTO_Log: '',
    Detection_Approval_reacd: '',
    Project_Brief: '',
    QC_Feedback_Tracker: '',
    Project_Plan_and_Tracker: '',
    No_of_ReworkingHrs:'',
    DRE_QC: '',
    DRE_Client: '',
    Customer_Complaints: '',
    notes: '',
    improvements: '',
    actualDeliveryDate:'',
  };
  pcrBasic:pcrReportBasic={ client: '',
  reels: '',
  shots: '',
  cluster: '',
  end_Date: '',
  pcrDate:'',
  pcrNumber:'',
  qcFrame: 0,
  fqaFrame: 0};
  honeyCombStatusReport:honeyCombStatusReport[]=[];
  operationReportType:operationReport[]=[];
  OperationReportClustorDetails:OperationReportClustorDetails[]=[];
  ProductivityReportbyTitleBreakDetails:ProductivityReportbyTitleBreakUp[]=[];
  dropTitleCode:dropTitleCode[]=[];
   FooterOperatorRemainter:string='';
   MetaDatatemplate:MetaDataTemplate[]=[];
   InventoryListDetails:InventoryListDetails[]=[];
   TitleInventoryNameList:Options[]=[];
   FrrInformationTitle:FrrInformationTitleDetails={
    title_Name:'',
    input_Format:'',
    out_Format:'',
    client_Requirement_Level_Requested:'',
    no_of_Reels:0,
    aspect_Ratio:'',
    total_Frames:0
  }  
  constructor() {
    makeAutoObservable(this);
  }

  QcData = async () => {
    try {
      this.loading = true;
      const response = await agent.Restoration.ItemListGetAllDetailsGet(1, 10);
      runInAction(() => {
        this.qcData = response.data;
        this.loading = false;
      });
    } catch (error) {
      console.log(error);
      this.loading = false;
    }
    //    const data = await
  };

  titleWiseReport = async (
    titleCode: string[],
    pageNumber: number,
    pageSize: number,
  ) => {
    try {
      this.loading = true;
      const response = await agent.Restoration.titleWiseSummary(
        titleCode,
        pageNumber,
        pageSize,
      );
      runInAction(() => {
        this.titleWiseData = response.data;
        this.loading = false;
      });
    } catch {
      toast.error('Something went wrong. Please try again !');
      this.loading = false;
    }
  };

  titleWiseSummaryCount = async () => {
    try {
      const response = await agent.Restoration.titleWiseSummaryCount();
      return response?.data;
    } catch {
      toast.error('Something went wrong. Please try again !');
    }
  };

  leadEmpID = async () => {
    try {
      const response = await agent.Restoration.leadEmpIDs();
      runInAction(() => {
        this.leadEmpId = response.data;
      });
    } catch {
      toast.error('Something went wrong , Please try again !');
    }
  };

  reelWiseReport = async (titlecode:string) => {
    try {
      const response = await agent.Restoration.reelWiseSummary(titlecode);
      runInAction(() => {
        this.reelWiseData = response.data;
      });
    } catch {
      toast.error('Something went wrong. Please try again !');
    }
  };

  teamName = async () => {
    try {
      const response = await agent.Restoration.teamNameLists();
      runInAction(() => {
        this.teamList = response.data;
      });
    } catch {
      toast.error('Something went wrong. Please try again !');
    }
  };

  cutlistStatusreport = async (titleCode: string) => {
    try {
      this.loading = true;
      this.cutlistQTLoader = true;
      const response = await agent.Restoration.cutliststatusreport(titleCode);
      runInAction(() => {
        this.cutlistStatusReportData = response.data;
        this.loading = false;
        this.cutlistQTLoader = false;
      });
    } catch {
      toast.error('Something went wrong. Please try again !');
      this.cutlistQTLoader = false;
      this.loading = false;
    }
  };

  qcperformance = async (titleCode: string) => {
    try {
      this.loading = true;
      this.cutlistQTLoader = true;
      const response = await agent.Restoration.qualityteamtitle(titleCode);
      runInAction(() => {
        this.dataqualityteamtitleperformace = response.data;
        this.loading = false;
        this.cutlistQTLoader = false;
      });
    } catch (error) {
      toast.error('Something went wrong. Please try again !');
      this.cutlistQTLoader = false;
      this.loading = false;
    }
  };

  plWiseReport = async (titleCode:string) => {
    try {
      const response = await agent.Restoration.plWiseSummary(titleCode);
      runInAction(() => {
        this.plWiseData = response.data;
      });
    } catch {
      toast.error('Something went wrong. Please try again !');
    }
  };

  qualityReport = async () => {
    try {
      // const payload = {
      //   PageNumber: 1,
      //   PageSize: 10,
      // };
      const response = await agent.Restoration.qualitySummary();
      runInAction(() => {
        this.qualityData = response.data;
      });
    } catch {
      toast.error('Something went wrong. Please try again !');
    }
  };

  getTitleCode = async () => {
    try {
      this.cutlistQTLoader = true;
      const response = await agent.Restoration.getTitlecode();
      runInAction(() => {
        this.titleCodeData = response.data;
      });
      this.cutlistQTLoader = false;
    } catch {
      this.cutlistQTLoader = false;
      toast.error('Something went wrong. Please try again !');
    }
  };

  pcEmpIdgets = async () => {
    try {
      const response = await agent.Restoration.pcEmpId();
      runInAction(() => {
        this.pcEmpIdGet = response.data;
      });
    } catch {
      toast.error('Something went wrong , Please try again !');
    }
  };

  OperatorEmpid = async () => {
    try {
      const response = await agent.Restoration.empId();
      runInAction(() => {
        this.operatorEmpIdGet = response.data;
      });
    } catch {
      toast.error('Some went wrong , Please try again');
    }
  };
  GetempnameFind = async (employeeId: string) => {
    try {
      const response = await agent.Restoration.empName(employeeId);
      return response.data;
      // runInAction(()=>{
      //   this.empnamefind=response.data;
      // });
    } catch {
      toast.error('Something went wrong. Please try again !');
    }
  };

  titleCodecount = async (titlecode: string) => {
    try {
      this.cutlistQTLoader = true;
      const response = await agent.Restoration.titleCodecount(titlecode);
      runInAction(() => {
        this.titleCodecountdata = response.data;
      });
      this.cutlistQTLoader = false;
    } catch {
      this.cutlistQTLoader = false;
      toast.error('Something went wrong. Please try again !');
    }
  };

  hoursCalculateReport = async () => {
    try {
      this.restorationReportLoader = true;
      this.manDaysReportTitleInfo.length = 0;

      const response = await agent.CGReports.hoursCalculate();
      runInAction(() => {
        this.manDaysData = response?.data;
        if (this.manDaysData.length) {
          let data: any[] = [];
          response?.data.forEach((item: any) => {
            data.push({
              key: item.title,
              value: item.title,
              text: item.title,
            });
          });
          this.manDaysReportTitleInfo = data
            .reduce((accumulator, current) => {
              const stringified = JSON.stringify(current);
              if (!accumulator.includes(stringified)) {
                accumulator.push(stringified);
              }
              return accumulator;
            }, [])
            .map(JSON.parse);
        }
      });
      this.restorationReportLoader = false;
    } catch {
      this.restorationReportLoader = false;
      toast.error('Something went wrong. Please try again !');
    }
  };
  titleWiseDefectReport = async (title: string) => {
    try {
      const response =
        await agent.Restoration.getAllTitleBasedDefectsAPI(title);
      runInAction(() => {
        this.responseForDefectData = response.data;
      });
    } catch (error) {
      toast.error('Something went wrong. Please try again !');
    }
  };
  dateWiseDefectReport = async (startDate: string, endingDate: string) => {
    try {
      const response = await agent.Restoration.getDateBasedDefectReportAPI(
        startDate,
        endingDate,
      );
      runInAction(() => {
        this.responseForDefectData = response.data;
      });
    } catch (error) {
      toast.error('Something went wrong. Please try again !');
    }
  };
  operatorPerformanceReport = async () => {
    try {
      this.restorationReportLoader = true;
      this.operatorPerformanceData.length = 0;
      const response = await agent.Restoration.operatorPerformance();
      // return response?.data;
      runInAction(() => {
        this.operatorPerformanceData = response.data;
        if (this.operatorPerformanceData.length) {
          let data: any[] = [];
          response?.data.forEach((item: any) => {
            data.push({
              key: item.title,
              value: item.title,
              text: item.title,
            });
          });
          this.performanceTitleCode = data
            .reduce((accumulator, current) => {
              const stringified = JSON.stringify(current);
              if (!accumulator.includes(stringified)) {
                accumulator.push(stringified);
              }
              return accumulator;
            }, [])
            .map(JSON.parse);
        }
      });
      this.restorationReportLoader = false;
      return response?.data;
    } catch {
      this.restorationReportLoader = false;
      toast.error('Something went wrong. Please try again !');
    }
  };

  performanceReportbyDateforDate = async (
    fromDate: string,
    lastDate: string,
  ) => {
    try {
      const response =
        await agent.Restoration.getDateBasedOperatorResponceReportAPI(
          fromDate,
          lastDate,
        );
      runInAction(() => {
        this.operatorPerformanceData = response.data;
      });
    } catch (error) {
      toast.error('Something went wrong. Please try again !');
    }
  };

  performanceReportbyTitle = async (inputTitle: string) => {
    try {
      const response =
        await agent.Restoration.getTitleBasedOperatorPerforanceReportAPI(
          inputTitle,
        );
      runInAction(() => {
        this.operatorPerformanceData = response.data;
      });
    } catch (error) {
      toast.error('Something went wrong. Please try again !');
    }
  };

  performanceQualityReportbyTitle = async (
    fromDate: string,
    lastDate: string,
  ) => {
    try {
      const response =
        await agent.Restoration.getDateBasedQualityResponceReportAPI(
          fromDate,
          lastDate,
        );
      runInAction(() => {
        this.dataqualityteamtitleperformace = response.data;
      });
    } catch (error) {
      toast.error('Something went wrong. Please try again !');
    }
  };

  restoratioHoursUpdate= async(value:any)=>{
     try {
      await agent.Restoration.restoratioHoursUpdate(value);
     } catch (error) {
      toast.error('Hours Update Failed...')
     }
  }

  HandleKeyReplace = (response:any)=>{
    const formattedResponse: ReportDetailsItem[] = response.data.map((item: ReportDetailsItem) => {
      const formattedItem: ReportDetailsItem = {};
      for (const key in item) {
          formattedItem[key.replace(/_/g, ' ').replace(/^\w/, c => c.toUpperCase())] = item[key];
      }
      return formattedItem;
  });
  return formattedResponse;
  }
  HandelTaskWiseOverAllTitle = async (fromDate:string,toDate:string)=>{
    try {
      this.restorationReportLoader = true;
      const response = await agent.Restoration.TaskWiseOverAllTitle(fromDate,toDate);
      const formattedResponse = await this.HandleKeyReplace(response);
      runInAction(()=>{
        this.reportDetails = formattedResponse
      })
      this.restorationReportLoader = false;
    } catch (error) {
      this.restorationReportLoader = false;
      console.log(error)
    }
  }
  HandelAllEmployeeDetails = async ()=>{
    try {
      this.restorationReportLoader = true;
      const response = await agent.Restoration.AllEmployeeDetails();
      const formattedResponse = await this.HandleKeyReplace(response);
      runInAction(()=>{
        this.reportDetails = formattedResponse
      })
      this.restorationReportLoader = false;
    } catch (error) {
      this.restorationReportLoader = false;
      console.log(error)
    }
  }
  productionTitleWiseReport = async(titleCode:string)=>{
    try {
      this.restorationReportLoader = true;
     const response =  await agent.Restoration.productionTitleWiseReport(titleCode);
     const formattedResponse = await this.HandleKeyReplace(response);
      runInAction(()=>{
        this.reportDetails = formattedResponse
      })
      this.restorationReportLoader = false;
    } catch (error) {
      this.restorationReportLoader = false;
      console.log(error)
    }
  }
  productionDateWiseReport = async(fromDate:string,toDate:string)=>{
    try {
      this.restorationReportLoader = true;
     const response =  await agent.Restoration.productionDateWiseReport(fromDate,toDate);
     const formattedResponse = await this.HandleKeyReplace(response);
      runInAction(()=>{
        this.reportDetails = formattedResponse
      })
      this.restorationReportLoader = false;
    } catch (error) {
      this.restorationReportLoader = false;
      console.log(error)
    }
  }
  ClusterWiseDateReport = async(fromDate:string,toDate:string,ClusterReport:string)=>{
    try {
      this.restorationReportLoader = true;
     const response =  await agent.Restoration.ClusterReport(fromDate,toDate,ClusterReport);
     const formattedResponse = await this.HandleKeyReplace(response);
      runInAction(()=>{
        this.reportDetails = formattedResponse
      })
      this.restorationReportLoader = false;
    } catch (error) {
      this.restorationReportLoader = false;
      console.log(error)
    }
}
     HandleClusterHeadEmployeeID = async()=>{
      try {
        const reposne = await agent.Restoration.ClusterHeadEmployeeID();
        runInAction(()=>{
          this.ClusterHeadEmployeeID = reposne.data;
        })
      } catch (error) {
        console.log(error)
      }
     }

    DefectInformation = async()=>{
      try {
        this.restorationReportLoader = true;
       const response =  await agent.Restoration.defectListDetails();
        runInAction(()=>{
          this.DefectTypesValue = response.data;
        })
        this.restorationReportLoader = false;
      } catch (error) {
        this.restorationReportLoader = false;
        toast.error('Some went wrong , Please try again');
      }
    }
    
    ClusterCapacityReport = async(fromDate:string,toDate:string)=>{
      try {
        const responseData=await agent.Restoration.ClusterCapacityReport(fromDate,toDate);
        runInAction(()=>{
          this.ClusterCapcityData=responseData.data;
        })
      }
      catch (error)
      {
        toast.error('Something went wrong. Please try again !');
      }
    }
    
    IndividualClusterCapacityReport = async(fromDate:string,toDate:string)=>{
      try {
        const individualResponseData =await  agent.Restoration.ClusterindividualCapacityReport(fromDate,toDate);
        runInAction(()=>{
          this.ClusterCapcityIndividualData=individualResponseData.data;
        })
      }
      catch (error)
      {
        toast.error('Something went wrong. Please try again !');
      }
    }
    DaywiseHoursAnalyzer = async(fromDate:string,toDate:string,titleChecked:boolean,dayHour:boolean)=>{
      try {
        const responseData=await agent.Restoration.DayWiseHours(fromDate,toDate,titleChecked,dayHour);
        runInAction(()=>{
          this.DayWiseHours=responseData.data;
        })
      } 
      catch (error) 
      {
        toast.error('Something went wrong. Please try again !');
      }
    }

    RestorationProductivityAPI = async(fromDate:string,toDate:string)=>{
      try {
        const responseData=await agent.Restoration.RestorationProductivityApiCall(fromDate,toDate);
        runInAction(()=>{
          this.RestorationProductivity=responseData.data;
        })
      } 
      catch (error) 
      {
        toast.error('Something went wrong. Please try again !');
      }
    }

    monthlyProductivity = async(month:string,year:string,employeeId:string)=>{
      try {
        const responseData=await agent.Restoration.monthlyProductivityReport(month,year,employeeId);
        runInAction(()=>{
          this.monthlyProductivitydata=responseData.data;
        })
      } 
      catch (error) 
      {
        toast.error('Something went wrong. Please try again !');
      }
    }

    monthlyProductivityByDate = async(month:string,year:string,employeeId:string)=>{
      try {
        const responseData=await agent.Restoration.monthlyProductivityReportByDate(month,year,employeeId );
        runInAction(()=>{
          this.monthlyProductivitydata=responseData.data;
        })
      } 
      catch (error) 
      {
        toast.error('Something went wrong. Please try again !');
      }
    }

    monthlyProductivityYear = async (): Promise<void> => {
      try {
        const response = await agent.Restoration.monthlyProductivityReportYear();
        runInAction(() => {
          this.monthlyProductivityYearData = response.data;
        });
      } catch {
        toast.error('Something went wrong, please try again');
      }
    };

    monthlyProductivityMonth = async (year:string) => {
      try {
        const response= await agent.Restoration.monthlyProductivityReportMonth(year);
        runInAction(() => {
          this.monthlyProductivityYearMonthData = response.data;
        });
      } catch {
        toast.error('Some went wrong , Please try again');
      }
    };

    
    TitleDashboardReport = async(fromDate:string,toDate:string)=>{
      try {
        this.restorationReportLoader = true;
       const response =  await agent.Restoration.TitleDashboardReport(fromDate,toDate);
        runInAction(()=>{
          this.TitleWiseDashboardData = response.data;
        })
        this.restorationReportLoader = false;
      } catch (error) {
        this.restorationReportLoader = false;
        toast.error('Some went wrong , Please try again');
      }
    };

    TitleDashboardInProgessTitle = async()=>{
      try {
        this.restorationReportLoader = true;
       const response =  await agent.Restoration.TitleDashboardInProgess();
        runInAction(()=>{
          this.TitleWiseDashboardData = response.data;
        })
        this.restorationReportLoader = false;
      } catch (error) {
        this.restorationReportLoader = false;
        toast.error('Some went wrong , Please try again');
      }
    };

    TitleDashboardSearchByTitle = async(inputTitleName:string,reportType:string)=>{
      try {
        this.restorationReportLoader = true;
        let response:any;
        if(reportType==='Search By Title Code')
          {
            response =  await agent.Restoration.TitleDashboardReportSearchByTitle(inputTitleName);
          }
        if(reportType==='Search By Project Name')
          {
           response =  await agent.Restoration.TitleDashboardReportSearchByProjectName(inputTitleName);
          }
        if(reportType==='Search By Client')
          {
            response =  await agent.Restoration.TitleDashboardReportSearchByClientName(inputTitleName);
          }
        //const response =  await agent.Restoration.TitleDashboardReportSearchByTitle(inputTitleName);
        runInAction(()=>{
          this.TitleWiseDashboardData = response.data;
        })
        this.restorationReportLoader = false;
      } catch (error) {
        this.restorationReportLoader = false;
        toast.error('Some went wrong , Please try again');
      }
    };


    PCRReportBasic = async(TitleCode:string)=>{
      try {
        this.restorationReportLoader = true;
       const response =  await agent.Restoration.basicPCRReport(TitleCode);
        runInAction(()=>{
          this.pcrBasic = response.data;
        })
        this.restorationReportLoader = false;
      } catch (error) {
        this.restorationReportLoader = false;
        toast.error('Some went wrong , Please try again');
      }
    };

    getPCRComments = async(TitleCode:string)=>{
      try {
        this.restorationReportLoader = true;
       const response =  await agent.Restoration.commentsgetPCRReport(TitleCode);
        runInAction(()=>{
          this.pcrCommentsDetails = response.data;
        })
        this.restorationReportLoader = false;
      } catch (error) {
        this.restorationReportLoader = false;
        toast.error('Some went wrong , Please try again');
      }
    };

    createPCRComments = async(payload:pcrCommentsPayload)=>{
      try {
        this.restorationReportLoader = true;
       const response =  await agent.Restoration.createComments(payload);
        runInAction(()=>{
          toast.success('Comments Add sucessfully')
        })
        this.restorationReportLoader = false;
        return response.data
      } catch (error) {
        this.restorationReportLoader = false;
        toast.error('Some went wrong , Please try again');
      }
    };
    RemovePCRComment = async(payload:pcrCommentsPayload)=>{
      try {
        this.restorationReportLoader = true;
       const response =  await agent.Restoration.removeComments(payload);
        runInAction(()=>{
         
          toast.success('Comments Remove sucessfully')
          return response.data
        })
        this.restorationReportLoader = false;
      } catch (error) {
        this.restorationReportLoader = false;
        toast.error('Some went wrong , Please try again');
      }
    };
    createPCRdetails = async(payload:pcrReportdetails)=>{
      try {
        this.restorationReportLoader = true;
       const response =  await agent.Restoration.createpcrDetail(payload);
        runInAction(()=>{
          this.pcrReportdetailsData = response.data;
        })
        this.restorationReportLoader = false;
      } catch (error) {
        this.restorationReportLoader = false;
        toast.error('Some went wrong , Please try again');
      }
    };
    PCRInformation = async(titleName:string)=>{
      try {
        this.restorationReportLoader = true;
       const response =  await agent.Restoration.pcrInformation(titleName);
        runInAction(()=>{
          this.pcrReportinforamationdata = response.data;
        })
        this.restorationReportLoader = false;
      } catch (error) {
        this.restorationReportLoader = false;
        toast.error('Some went wrong , Please try again');
      }
    };
    createFfraddress= async(payload:frrReportAddress)=>{
      try {
        this.restorationReportLoader = true;
       const response =  await agent.Restoration.createFRRadress(payload);
        runInAction(()=>{
          toast.success('Comments Add sucessfully')
        })
        this.restorationReportLoader = false;
        return response.data
      } catch (error) {
        this.restorationReportLoader = false;
        toast.error('Some went wrong , Please try again');
      }
    };

    createFrrDetails= async(payload:FrrInformData)=>{
      try {
     
        this.restorationReportLoader = true;
        const response =  await agent.Restoration.CreateFrrDetails(payload);
        runInAction(()=>{
          toast.success('FRR Report Updated Successfully');
        })
        this.restorationReportLoader = false;
        return response.data
      } catch (error) {
        this.restorationReportLoader = false;
        toast.error('Some went wrong , Please try again');
      }
    };

    deleteFrrAddress=async(TitleCode:string,reelName:string,addressNo:number)=>
    {
      try {
        this.restorationReportLoader = true;
        const response =  await agent.Restoration.removeFrrAddress(TitleCode,reelName,addressNo);
        runInAction(()=>{
          toast.success('FRR Removed Successfully');
        })
        this.restorationReportLoader = false;
        return response.data
      } catch (error) {
        this.restorationReportLoader = false;
        toast.error('Some went wrong , Please try again');
      }
    };
      getFfrAddress = async(TitleCode:string)=>{
            try {
              this.restorationReportLoader = true;
            const response =  await agent.Restoration.FrrAddressList(TitleCode);
              runInAction(()=>{
                this.getFrrReportAddress = response.data;
              })
              this.restorationReportLoader = false;
            } 
            catch (error) 
            {
              this.restorationReportLoader = false;
              toast.error('Some went wrong , Please try again');
            }
          };
    getFrrInformation=async(TitleCode:string)=>{
      try {
        this.restorationReportLoader = true;
        const response =  await agent.Restoration.getFinalRestorationReport(TitleCode);
        runInAction(()=>{
          this.getFrrInformData=response.data;
        })
        this.restorationReportLoader = false;
      }
      catch (error) {
        this.restorationReportLoader = false;
        toast.error('Some went wrong , Please try again');
      }
    };
    getLogStatus=async()=>{
      try {
        this.restorationReportLoader = true;
        const response =  store.userStore.user?.customerName === 'NFAIReport' ? 
        await NFAI_Restoration_SmartflowServices.honeyCombStatusReport() : 
        await agent.Restoration.getHoneyCombStatusReport();
        runInAction(()=>{
          this.honeyCombStatusReport=response.data;
        })
        this.restorationReportLoader = false;
      }
      catch (error) {
        this.restorationReportLoader = false;
        toast.error('Some went wrong , Please try again');
      }
    };
    OperationReportAPICall = async(month:string,year:string)=>{
      try {
        const responseData=await agent.Restoration.operationReportApi(month,year);
        runInAction(()=>{
          this.operationReportType=responseData.data;
        })
      } 
      catch (error) 
      {
        toast.error('Something went wrong. Please try again !');
      }
    }
     ClusterOperationReportAPICall = async ( month: string,year: string,fromDate: string,toDate: string,) => {
    try {
      const responseData =
        await agent.Restoration.operationReportByClusterWiseApi(
          month,
          year,
          fromDate,
          toDate,
        );
      runInAction(() => {
        this.OperationReportClustorDetails = responseData.data;
      });
    } catch (error) {
      toast.error('Something went wrong. Please try again !');
    }
  };
    ProductivityReportbyTitleBreakUpAPICall = async(month:string,year:string,employeeId:string)=>{
      try {
        const responseData=await agent.Restoration.ProductivityReportbyTitleBreakUpApi(month,year,employeeId);
        runInAction(()=>{
          this.ProductivityReportbyTitleBreakDetails=responseData.data;
        })
      } 
      catch (error) 
      {
        toast.error('Something went wrong. Please try again !');
      }
    }

    ProductivityReportbyTitleBreakUpAPICallByDate = async(month:string,year:string,employeeId:string)=>{
      try {
        const responseData=await agent.Restoration.ProductivityReportbyTitleBreakUpApiByDate(month,year,employeeId);
        runInAction(()=>{
          this.ProductivityReportbyTitleBreakDetails=responseData.data;
        })
      } 
      catch (error) 
      {
        toast.error('Something went wrong. Please try again !');
      }
    }

    getLiveTitleCode = async () => {
      try {
        this.cutlistQTLoader = true;
        const response = await agent.Restoration.OpenTitle();
        runInAction(() => {
          this.dropTitleCode = response.data;
        });
        this.cutlistQTLoader = false;
      } catch {
        this.cutlistQTLoader = false;
        toast.error('Something went wrong. Please try again !');
      }
    };

    OperatorRemainter = async ()=>{
      try {
        this.FooterOperatorRemainter='';
        const reponse = await agent.SmartTracker.OperatorRemainter();
        runInAction(()=>{
          this.FooterOperatorRemainter = reponse.data;
        })
      } catch (error) {
        console.log(error)
      }
    }

    MetaDatafieldsName = async ()=>{
      try {
        this.FooterOperatorRemainter='';
        const reponse = await agent.SingleTitlePageTitleCreate.MetaDataFieldName();
        runInAction(()=>{
          this.MetaDatatemplate = reponse.data;
        })
      } catch (error) {
        console.log(error)
      }
    }

    CreateSingle= async(Medatainfo:MetaDataTemplate[])=>{
      try {
        const response =  await agent.SingleTitlePageTitleCreate.CGTitleCreate(Medatainfo);
        runInAction(()=>{
          toast.success('Create Successfully ');
        })
       
        return response.data
      } catch (error) {
        toast.error('Some went wrong , Please try again');
      }
    };

    FrrGetandGenerateComments = async(inputTitleName:string)=>{
      try {
        this.restorationReportLoader = true;
       const response =  await agent.Restoration.FrrInformationGetandGenerateComments(inputTitleName);
        runInAction(()=>{
          this.FrrInformationTitle = response.data;
        })
        this.restorationReportLoader = false;
      } catch (error) {
        this.restorationReportLoader = false;
        toast.error('Some went wrong , Please try again');
      }
    };
    TitleReelInventoryDetails= async(titleCode:string)=>{
      try {
        const response =  await agent.SingleTitlePageTitleCreate.ReelInventoryDetails(titleCode);
        runInAction(()=>{
          this.InventoryListDetails = response.data;
        })

      } catch (error) {
        toast.error('Some went wrong , Please try again');
      }
    };
    CreateTitleReelInventory= async(itemID:string,inventory:InventoryList[])=>{
      try {
        const response =  await agent.SingleTitlePageTitleCreate.TitleInventoryCrate(itemID,inventory);
        runInAction(()=>{
          toast.success('Create Successfully ');
        })

        return response.data
      } catch (error) {
        toast.error('Some went wrong , Please try again');
      }
    };
    TitleReelInventoryRemoved= async(ReelId:string)=>{
      try {
        const response =  await agent.SingleTitlePageTitleCreate.DeleteReelName(ReelId);
        runInAction(()=>{
          toast.success(response.data);
        })

      } catch (error) {
        toast.error('Some went wrong , Please try again');
      }
    };
    TitleInformation= async(titleCodeName:string)=>{
      try {
        const response =  await agent.SingleTitlePageTitleCreate.returnTitleID(titleCodeName);
        runInAction(()=>{
          const titleData = response.data;
          return titleData;
        })
        return response.data

      } catch (error) {
        toast.error('Some went wrong , Please try again');
      }
    };

    TitleReelNameListOption= async(itemID:string)=>{
      try {
        const response =  await agent.SingleTitlePageTitleCreate.returnTitleReelList(itemID);
        runInAction(()=>{
          this.TitleInventoryNameList = response.data;
        })
      } catch (error) {
        toast.error('Some went wrong , Please try again');
      }
    };
    
    TitleReelInventoryUpdate= async(inventory:InventoryListDetails)=>{
      try {
        const response =  await agent.SingleTitlePageTitleCreate.TitleInventoryUpdate(inventory);
        runInAction(()=>{
          toast.success('Inventory Updated Successfully ');
        })

        return response.data
      } catch (error) {
        toast.error('Some went wrong , Please try again');
      }
    };

}

